import { Checkbox } from '@material-ui/core';
import ReactGA from 'react-ga';
import React from 'react';
import styles, { useStyles } from './OptionsBoardStyles';
import FavIcon from './icon.png';
import { useDispatch, useSelector } from 'react-redux';
import { setOptionChainAction } from '../../actions/optionChainAction';

const StrikeNear = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { appReducer, optionChainReducer } = useSelector((state) => state);
  const { isMobile, accessLevel } = appReducer;

  const { watchListModalIndex, strikeWidth, favioute, hideShading } =
    optionChainReducer;

  const setWatchModal = async () => {
    const fav = !favioute;
    dispatch(
      setOptionChainAction({
        favioute: fav,
      })
    );
    if (watchListModalIndex.length && fav === false) {
      await dispatch(setOptionChainAction({ watchListModal: true }));
      return;
    }
  };

  const toggleShading = () => {
    dispatch(
      setOptionChainAction({
        hideShading: !hideShading,
      })
    );
    ReactGA.event({
      category: 'ChainAction',
      action: 'Toggle Shading',
      label: `${!hideShading}`,
    });
  };

  return (
    <div
      className="sticky"
      style={
        isMobile
          ? styles.basicBoardsWrappeInput
          : {
              ...styles.strikeOB,
              maxWidth: window.innerWidth > 2200 ? '' : '740px',
              width: window.innerWidth > 2200 ? strikeWidth : '',
            }
      }
    >
      <div style={{ display: 'flex' }}>
        <div style={isMobile ? styles.spaanMobile : styles.spaan}>
          {/* Strikes:{" "} */}
        </div>{' '}
      </div>
      <div style={{ display: 'flex' }}></div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'end',
          paddingRight: '10px',
          position: 'absolute',
          right: 0,
        }}
      >
        <div style={isMobile ? { display: 'none' } : styles.spaan}>
          Watchlist
        </div>
        <div
          style={{
            height: '20px',
            width: '50px',
            marginTop: '10px',
            display: !isMobile ? 'none' : '',
          }}
        >
          <img height="100%" width="100%" src={FavIcon} alt="" />
        </div>
        <Checkbox
          disabled={accessLevel === 'fullaccess' ? false : true}
          style={{ marginRight: '10px' }}
          checked={favioute}
          onClick={() => setWatchModal()}
          classes={{ root: classes.root }}
        />
        <div style={isMobile ? { display: 'none' } : styles.spaan}>Shade</div>{' '}
        <Checkbox
          style={isMobile ? { display: 'none' } : {}}
          checked={!hideShading}
          onClick={() => toggleShading()}
          classes={{ root: classes.root }}
        />
      </div>
    </div>
  );
};

export default StrikeNear;



// WEBPACK FOOTER //
// ./src/Pages/OptionsBoard/StrikeNear.jsx